<ng-container *ngIf="model">
  <div
    *ngIf="borderRadius"
    [ngClass]="{
      rectangle: borderRadius === 'full',
      'rectangle-radius-top': borderRadius === 'top',
      'rectangle-radius-bottom': borderRadius === 'bottom',
      'rectangle-no-radius': borderRadius === 'none'
    }"
  ></div>
  <div class="preformatted-container">
    <ng-container [ngSwitch]="item.type" *ngFor="let item of model.elements || []">
      <ng-container *ngSwitchCase="'text'">
        <result-rich-text-text [model]="item" [highlights]="highlights"></result-rich-text-text>
      </ng-container>
      <ng-container *ngSwitchCase="'link'">
        <result-rich-text-link (invoke)="invoke.emit($event)" [model]="item" [highlights]="highlights"></result-rich-text-link>
      </ng-container>
    </ng-container>
  </div>
</ng-container>
